import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
export const MastheadBladeSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    backdrop: BackdropSchema.optional(),
});
export const MastheadBladeTypeValues = ["centerPromoMasthead", "mediaMasthead", "textMasthead"];
export const MastheadBladeTypesSchema = z.enum(MastheadBladeTypeValues);
export const MastheadBladeTypes = MastheadBladeTypesSchema.enum;
export const MastheadBladesContractSchema = MastheadBladeSchema.extend({
    type: MastheadBladeTypesSchema,
});
export const CenterPromoMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal(MastheadBladeTypes.centerPromoMasthead),
});
export const MediaMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal(MastheadBladeTypes.mediaMasthead),
});
export const TextMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal(MastheadBladeTypes.textMasthead),
});
//# sourceMappingURL=index.js.map